import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import Helpers, { isActiveSlide, isActiveSidebar, advBookSeries, isSelected } from "../../../../config/Helpers";
import axios from "axios";
import { parse } from "querystring";

const postUrlDimensions  = API_URL + "dimensions";


class SidebarReview extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            series : {
                revenew : "",
                room_night : "",
                adr : "",
                budget_vs_revenue : "",
                budget_vs_room_night : "",
                budget_vs_adr : ""
            },
            period_menu_show : "hide-panel",
        }
    }
    handleClickMenu() {
        this.state.period_menu_show === "hide-panel" ? this.setState({ period_menu_show : "" }) : this.setState({ period_menu_show : "hide-panel" });
    }
    handleClickMenuItem(key, value){
        const current_period  =  { 
            key : key, value : value 
        }
        this.props.setPeriodSidebarReview(current_period)
    }

    componentWillReceiveProps(props){
        let char_keys = Object.keys(props.response_request);
        let $self = this;
        let series
        if (char_keys.length > 0){
            series  = props.response_request["data_production_year"]["totals"];
            Object.keys($self.state.series).map(function(key_value, index){
                let title, current_value, last_value, comp = 0;

                if(key_value === "revenew"){
                    
                    title           = "REVENUE";
                    current_value   = "$" + series["revenue_by_widget"];
                    last_value      = "$" + series["revenue_by_widget_ly"];
                    comp            = series["comp_revenue_by_widget"];

                }else if(key_value === "room_night"){
                    title           = "PAX";
                    current_value   = series["room_nights_books_by_widget"];
                    last_value      = series["room_nights_by_widget_ly"];
                    comp            = series["comp_room_nights_books_by_widget"];

                }else if(key_value === "adr"){
                    title = "REV/PAX";
                    current_value   = "$" + series["adr_books_by_widget"];
                    last_value      = "$" + series["adr_ly_by_widget"];
                    comp            = series["comp_adr_books_by_widget"];

                }else if(key_value === "budget_vs_revenue"){
                    title = "REVENUE VS. BUDGET";
                    current_value   = series["revenue_bb_by_widget"] + "%";
                    last_value      = series["revenue_bb_by_widget_ly"] + "%";
                    comp            = series["comp_revenue_bb_by_widget"];

                }else if(key_value === "budget_vs_room_night"){
                    title = "PAX VS. BUDGET";
                    current_value   = series["room_nights_bb_by_widget"] + "%";
                    last_value      = series["room_nights_bb_by_widget_ly"] + "%";
                    comp            = series["comp_room_nights_bb_by_widget"];
                }else{
                    title = "ADR VS. BUDGET";
                    current_value   = series["adr_bb_by_widget"] + "%";
                    last_value      = series["adr_bb_by_widget_ly"] + "%";
                    comp            = series["comp_adr_bb_by_widget"];
                }
                let is_better = parseFloat(comp) !== 0 ? (parseFloat(comp) < 0 ? "worst" : "best") : "hide"
                $self.state.series[key_value] = (
                    <div className="sidebar-wdg">
                        <span className="title">{ title }</span>
                        <span className="highlight-title">{ current_value }</span>
                        <div className="footer">
                            <div className="block-1">
                                <span className="last-year">LAST YEAR</span>
                                <span className="highlight-last-year">{ last_value }</span>
                            </div>
                            <div className="block-2">
                                <span className={"rate-type " + is_better}></span>
                                <span className="highlight-rate">
                                    { comp }%
                                </span>
                            </div>
                        </div>
                    </div>
                )
            })
        }
    }
    activeSidebar(){
        this.props.setStateSidebarReview()
        if(this.props.sidebar_review.status === ""){
            this.setState({
                period_menu_show : "hide-panel"
            })
        }
    }

    render(){
        const items_series = advBookSeries.map((item, index) =>
            <li onClick={this.handleClickMenuItem.bind(this, item.key, item.value)}>
                {item.key}
            </li>
        );
        return (
            <div className={"sidebar-review " + this.props.sidebar_review.status + " " + this.props.sidebar_review.show}>
                <div className="head-sidebar">
                    <span onClick={this.activeSidebar.bind(this)} className="arrow-press">
                        <span className="arrow"></span>
                    </span>
                    <div className="select-style type-two ">
                        <span className="input-filters select blue not-arrow">
                            <span title="Room Nigths">REVIEW</span>
                        </span>
                    </div>
                </div>
                <div className="container-review">
                    <div>
                        {this.state.series.revenew}
                    </div>
                    <div>
                        {this.state.series.adr}
                    </div>
                    <div>
                        {this.state.series.room_night}
                    </div>
                    <div>
                        {this.state.series.budget_vs_revenue}
                    </div>
                    <div>
                        {this.state.series.budget_vs_room_night}
                    </div>
                    <div>
                        {this.state.series.budget_vs_adr}
                    </div>
                </div>
            </div>
        )
    }
}

export default SidebarReview


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/widgets/SidebarReview.js